module.exports = __webpack_public_path__ + "static/availability_1-780b9381b38a73ca70b801cc909c46e8.jpg";